<div #root class="dashboard-root">
  <div class="image">
    <!--    <div class="image-dashboard"></div>-->
  </div>
  <div class="menu">
    <div class="content-menu">
      <div class="menu-title">
        Bienvenue dans votre espace client
      </div>
      <div class="menu-sub-title">
        Retrouvez les informations dont vous aurez besoin concernant votre projet
      </div>
      <div class="item-menu">
        <div class="item" (click)="onNavigateTo('files')">
          <div class="icon-menu">
            <fa-icon [icon]="['fal','folders']"></fa-icon>
          </div>
          <div class="info-menu">
            <div class="title-menu"> Vos documents </div>
            <div class="description-menu">Accédez à contrats, plans, maquettes</div>
          </div>
        </div>
        <div class="item" (click)="onNavigateTo('quotations')">
          <div class="icon-menu">
            <fa-icon [icon]="['fal','file-invoice-dollar']"></fa-icon>
          </div>
          <div class="info-menu">
            <div class="title-menu"> Vos devis & avenants </div>
            <div class="description-menu">Accédez au suivi financier mis à jour en temps réel</div>
          </div>
        </div>
      </div>
      <div class="item-menu">
        <ng-container *ngIf="dataMaterialsService.hasProjectMaterials()">
          <div class="item" (click)="onNavigateTo('materials', 'orders')">
            <div class="icon-menu">
              <fa-icon [icon]="['fal','luggage-cart']"></fa-icon>
            </div>
            <div class="info-menu">
              <div class="title-menu"> Vos matériaux </div>
              <div class="description-menu">Accédez au suivi de vos matériaux</div>
            </div>
          </div>
        </ng-container>
        <div class="item" (click)="onNavigateTo('schedule')">
          <div class="icon-menu">
            <fa-icon [icon]="['fal','calendar-check']"></fa-icon>
          </div>
          <div class="info-menu">
            <div class="title-menu"> Votre planning </div>
            <div class="description-menu">Suivez l'avancée de votre chantier étape par étape</div>
          </div>
        </div>
      </div>
      <div class="item-menu" *ngIf="checkStep()">
        <div class="item" (click)="onNavigateTo('balance')">
          <div class="icon-menu">
            <fa-icon [icon]="['fal','sack-dollar']"></fa-icon>
          </div>
          <div class="info-menu">
            <div class="title-menu"> Vos échéances </div>
            <div class="description-menu">Surveillez vos prochaines échéances de paiement</div>
          </div>
        </div>
        <div class="item" (click)="onNavigateTo('chantier')">
          <div class="icon-menu">
            <fa-icon [icon]="['fal','comment-alt-lines']"></fa-icon>
          </div>
          <div class="info-menu">
            <div class="title-menu"> Votre chantier </div>
            <div class="description-menu"> Suivez tous les sujets importants de votre chantier </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

